export const HOME = 'home';



// WEBPACK FOOTER //
// ./app/constants/subjectType.js